export default __webpack_public_path__ + "static/univers-bold-cond-14432cd4337dc1113a4947b3dc03bc92.woff2";